import {affiliatePattern} from "../src/affiliate-pattern";

let links = document.getElementsByTagName("a");

for (let i = links.length - 1; i >= 0; i--) {
    let isReferral = links[i].href.search(affiliatePattern) !== -1;

    if (links[i].hostname !== location.hostname || isReferral) {
        links[i].target = "_blank";
    }
}